export function AnnouncementBar() {
  return (
    <div className="announcement-bar">
      <p>Personalized gifts, made for the moments that matter.</p>
    </div>
  );
}
